/**
 * Auth-page left-panel banner — single place to swap the visual.
 *
 * Generated via glowtest_BE (Recraft v4, 1024x1024 1:1 JPEG) with the same
 * pipeline used for the pitch-deck visuals. Source prompts + S3 records live in
 * `public/auth/source/login-banner-{1,2,3}.json` (regenerate with
 * `scripts/auth_banner_generate.py`).
 *
 * Variations:
 *  - login-banner-1  persona_welcome     — Raisy persona, warm open-hand welcome
 *  - login-banner-2  abstract_corporate  — teal abstract network (DEFAULT — PO pick,
 *                                          most legible behind text, ratio-safe)
 *  - login-banner-3  persona_system      — Raisy persona + operating-system layers
 *
 * The source is square (1:1) so it crops safely with object-cover to the
 * auth panel's varying ratios (short laptop → tall ultrawide) and to a
 * future mobile/og use without losing the subject.
 */
export const AUTH_VISUAL = {
  image: "/auth/login-banner-2.jpg",
  tagline: "AI prepares. Humans decide.",
  subcopy:
    "Raisy turns your operations into a governed AI workforce — you review, you approve, you stay in control.",
};
